import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import bcrypt from 'bcryptjs';
const initialState={
    loginstatus:'',
    username:sessionStorage.getItem('username') || '',
    id:sessionStorage.getItem('id') || '',
    isLoggedIn:!!sessionStorage.getItem('username'),
    userList:[],
    selectedUser: null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:'',
    user:{
        'id':0,
        'username': '',
        'password': '',
        'name': '',
        'surname': '',
        'mobile': '',
        'email': '',
        'isAdmin': '',
        'lastActivity': '',
        'dateCreated': '',
        'isfromVisitor': '',
    }
}

export const loginUser = createAsyncThunk('login/User',async(user)=>{
    console.log(user, 'logging in')
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/users/getUserByUsername/${user.username}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    );
    let fetchuser = await response.json()
    //console.log(fetchuser.password, "  jjj")
    //console.log(bcrypt.compareSync(user.password,fetchuser.password))
    //console.log("lng" ,fetchuser.password.length)

    if(fetchuser.password.length > 0 && bcrypt.compareSync(user.password,fetchuser.password))
    {
        console.log("if inside")
        return Promise.resolve(fetchuser);
    }
    return Promise.reject('error')
})


export const fetchUsers=createAsyncThunk('users/fetchUsers', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/user/getUsers',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchUserById=createAsyncThunk('users/fetchUserById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/user/getUserById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const updateUser=createAsyncThunk('users/updateUser', async ({user,cid})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/user/updateUser/${cid}`,
        {
            method:'POST',
            body: JSON.stringify(user),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

const userSlice=createSlice({
    name:'users',
    initialState,
    reducers:{
        changeRegisterStatus: (state) => {
            state.registerstatus = 'failure';
        },
        changeEditStatus: (state) => {
            state.editstatus = 'failure';
        },
        logoutUser:(state, action)=>{
            sessionStorage.removeItem('username');
            sessionStorage.removeItem('id');
            sessionStorage.removeItem('loged');
            state.loginstatus = 'failure';
            state.username='';
        },
    },
    extraReducers:(builder)=>{
        builder
            .addCase(loginUser.fulfilled,(state, action)=>{
                //console.log("logged in ",action.payload);
                state.loginstatus = 'success';
                state.user=action.payload;
                state.username = action.payload.username;
                state.id=action.payload.id;
                state.isLoggedIn= true;
                sessionStorage.setItem('username', state.username);
                sessionStorage.setItem('id', state.id);
                sessionStorage.setItem('loged', state.user);
            })
            .addCase(loginUser.rejected,(state, action)=>{
                state.loginstatus = 'failure';
                state.username = ''
                state.isLoggedIn= false
            })
        .addCase(fetchUsers.pending, (state)=>{
            state.status='loading'
        })
        .addCase(fetchUsers.fulfilled, (state, action)=>{
            state.status='succeeded'
            state.userList=action.payload
        })
        .addCase(fetchUsers.rejected, (state, action)=>{
            state.status='failed'
            state.error=action.error.message
        })
        .addCase(fetchUserById.pending, (state)=>{
            state.status='loading'
        })
        .addCase(fetchUserById.fulfilled, (state, action)=>{
            state.status='succeeded'
            state.selectedUser=action.payload
        })
        .addCase(fetchUserById.rejected, (state, action)=>{
            state.status='failed'
            state.error=action.error.message
        })
        .addCase(updateUser.pending, (state)=>{
            state.editstatus='loading'
        })
        .addCase(updateUser.fulfilled, (state, action)=>{
            state.editstatus='succeeded'
            const index = state.userList.findIndex(user => user.id === action.payload.id)
            if(index !== -1){
                state.userList[index] = action.payload
            }
        })
        .addCase(updateUser.rejected, (state, action)=>{
            state.editstatus='failed'
            state.error=action.error.message
        })
    }
})

export let {isLoggedIn} = state => state.userreducer.isLoggedIn
export let {logoutUser,changeRegisterStatus} = userSlice.actions

export default userSlice.reducer;